import { RouteConfig } from './common/components/RouteWithSubRoutes';
import Dashboard from './features/dashboard/Dashboard';
import Login from './features/authentication/login/Login';
import Logout from './features/authentication/Logout';
import Site from './features/site/Site';
import SiteDetails from './features/site/site-details/SiteDetails';
import CustomerDetails from './features/site/customer-details/CustomerDetails';
import SystemDetails from './features/site/system-details/SystemDetails';
import MeterSetup from './features/site/meter-setup/MeterSetup';
import MeterSetupForm from './features/site/meter-setup/MeterSetupForm';
import CircuitTests from './features/site/meter-setup/circuit-tests/CircuitTests';
import CTConfiguration from './features/site/meter-setup/ct-configuration/CTConfigurationContainer';
import LoadAppliances from './features/site/meter-setup/circuit-tests/LoadAppliances';
import GridTest from './features/site/meter-setup/circuit-tests/GridTest';
import SolarTest from './features/site/meter-setup/circuit-tests/SolarTest';
import Account from './features/user/account/Account';
import AccountHome from './features/user/account/AccountHome';
import AccountSettings from './features/user/account/AccountSettings';
import AccountAbout from './features/user/account/AccountAbout';
import { SiteNavLink } from './features/navigation/custom-nav-hooks';
import {
  AccountIconActive,
  AccountIconInactive,
  UpsellActiveIcon,
  UpsellIcon,
  DashboardIconActive,
  DashboardIconInactive,
  SitesIconActive,
  SitesIconInactive,
} from './styles/custom-icons';
import FleetDashboard from './features/fleet-dashboard/FleetDashboard';
import * as React from 'react';
import LoadTest from './features/site/meter-setup/circuit-tests/LoadTest';
import MeterSetupPollingWrapper from './features/site/meter-setup/MeterSetupPollingWrapper';
import HybridTest from './features/site/meter-setup/circuit-tests/HybridInverterTest';
import BatteryTest from './features/site/meter-setup/circuit-tests/BatteryTest';
import Signup from './features/authentication/signup/Signup';
import ManageUsers from './features/user/account/manage-users/ManageUsers';
import BusinessDetails from './features/user/account/BusinessDetails';
import BatteryUpsell from './features/upsell/BatteryUpsell';
import BatteryUpsellSimulations from './features/upsell/BatteryUpsellSimulations';
import SwitchConfiguration from './features/site/meter-setup/switch-configuration/SwitchConfigurationContainer';
import BatteryUpsellDashboard from './features/upsell/BatteryUpsellDashboard';
import WifiConfiguration from './features/site/meter-setup/wifi-configuration/WifiConfiguration';

export const ALL_ROUTES: RouteConfig[] = [
  {
    path: '/dashboard',
    component: Dashboard,
    requiresLogin: true,
    routes: [],
  },
  {
    path: '/login',
    component: Login,
    requiresLogin: false,
    routes: [],
  },
  {
    path: '/signup',
    component: Signup,
    requiresLogin: false,
    routes: [],
  },
  {
    path: '/logout',
    component: Logout,
    requiresLogin: false,
    routes: [],
  },
  {
    path: '/site/:id',
    component: Site,
    requiresLogin: true,
    routes: [
      {
        path: '/site/:id/start',
        component: SiteDetails,
        componentName: 'SiteDetails',
        requiresLogin: true,
        routes: [],
      },
      {
        path: '/site/:id/customer_details',
        component: CustomerDetails,
        componentName: 'CustomerDetails',
        requiresLogin: true,
        routes: [],
      },
      {
        path: '/site/:id/system_details',
        component: SystemDetails,
        componentName: 'SystemDetails',
        requiresLogin: true,
        routes: [],
      },
      {
        path: '/site/:id/meter_setup',
        component: MeterSetup,
        componentName: 'MeterSetup',
        requiresLogin: true,
        routes: [
          {
            path: '/site/:id/meter_setup/meters',
            component: MeterSetupForm,
            requiresLogin: true,
            routes: [],
          },
          {
            path: '/site/:id/meter_setup/configure',
            component: MeterSetupPollingWrapper,
            requiresLogin: true,
            routes: [
              {
                path: '/site/:id/meter_setup/configure/meter_tests',
                component: CircuitTests,
                requiresLogin: true,
                routes: [],
              },
              {
                path: '/site/:id/meter_setup/configure/ct_configuration',
                component: CTConfiguration,
                requiresLogin: true,
                routes: [],
              },
              {
                path: '/site/:id/meter_setup/configure/wifi_configuration',
                component: WifiConfiguration,
                requiresLogin: true,
                routes: [],
              },
              {
                path: '/site/:id/meter_setup/configure/switch_configuration',
                component: SwitchConfiguration,
                requiresLogin: true,
                routes: [],
              },
              {
                path: '/site/:id/meter_setup/configure/loads_list',
                component: LoadAppliances,
                requiresLogin: true,
                routes: [],
              },
              {
                path: '/site/:id/meter_setup/configure/loads/:appliance_id',
                component: LoadTest,
                requiresLogin: true,
                routes: [],
              },
              {
                path: '/site/:id/meter_setup/configure/grid',
                component: GridTest,
                requiresLogin: true,
                routes: [],
              },
              {
                path: '/site/:id/meter_setup/configure/solar',
                component: SolarTest,
                requiresLogin: true,
                routes: [],
              },
              {
                path: '/site/:id/meter_setup/configure/hybrid',
                component: HybridTest,
                requiresLogin: true,
                routes: [],
              },
              {
                path: '/site/:id/meter_setup/configure/battery',
                component: BatteryTest,
                requiresLogin: true,
                routes: [],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: '/account',
    component: Account,
    requiresLogin: true,
    routes: [
      {
        path: '/account/home',
        component: AccountHome,
        requiresLogin: true,
        routes: [],
      },
      {
        path: '/account/settings',
        component: AccountSettings,
        requiresLogin: true,
        routes: [],
      },
      {
        path: '/account/about',
        component: AccountAbout,
        requiresLogin: true,
        routes: [],
      },
      {
        path: '/account/manage_users',
        component: ManageUsers,
        requiresLogin: true,
        routes: [],
      },
      {
        path: '/account/business_details',
        component: BusinessDetails,
        requiresLogin: true,
        routes: [],
      },
    ],
  },
  {
    path: '/fleet_dashboard',
    component: FleetDashboard,
    requiresLogin: true,
    routes: [],
  },
  {
    path: '/upsells',
    component: BatteryUpsell,
    requiresLogin: true,
    routes: [
      {
        path: '/upsells/home',
        component: BatteryUpsellDashboard,
        requiresLogin: true,
        routes: [],
      },
      {
        path: '/upsells/site/:id/simulations',
        component: BatteryUpsellSimulations,
        requiresLogin: true,
        routes: [],
      },
    ],
  },
];

export const routes = ALL_ROUTES.map((route) => {
  if (route.path !== '/site/:id') return route;
  return { ...route, routes: route.routes };
});

export const NAV_LINKS: SiteNavLink[] = [
  {
    route: '/fleet_dashboard',
    routeName: 'Fleet Dashboard',
    ariaLabel: 'Fleet Dashboard',
    icon: <DashboardIconInactive />,
    activeIcon: <DashboardIconActive color="primaryBrandingStatic.500" />,
  },
  {
    route: '/dashboard',
    routeName: 'Sites',
    ariaLabel: 'Sites',
    icon: <SitesIconInactive />,
    activeIcon: <SitesIconActive color="primaryBrandingStatic.500" />,
  },
  {
    route: '/upsells',
    routeName: 'Upsells',
    ariaLabel: 'Upsells',
    isNew: true,
    icon: <UpsellIcon />,
    activeIcon: <UpsellActiveIcon color="primaryBrandingStatic.500" />,
  },
  {
    route: '/account/home',
    routeName: 'Account',
    ariaLabel: 'Account',
    icon: <AccountIconInactive />,
    activeIcon: <AccountIconActive color="primaryBrandingStatic.500" />,
  },
];
